import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { mainMenu } from './services/route.service';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: mainMenu
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/main.routing.ts